<template>
  <div class="products-result-base" :style="styles">
    <div class="header-area">
      <h1><img src="/static/img/recommend/lp/houen/products/reslut_topimg02.png"></h1>
      <div class="link-block">
        <a href="/products/45">< 占い特集TOPへ</a>
      </div>
    </div>

    <block-result-type03
      base-title="運命の人の生まれ月"
      lower-menu-title="あなたを幸せに導く運命の人は？"
      :result-data="resultData"
      :csrf-token="csrfToken"
    />

    <div class="block-regist-info" v-if="hasResult">
      <img class="line-top" src="/static/img/recommend/lp/houen/products/whiteline_top.png">
      <h2></h2>
      <regist-birthdate header-word="他の誕生日で占う" :csrf-token="csrfToken" reg-btn-face="占う" />
      <img class="line-bottom" src="/static/img/recommend/lp/houen/products/whiteline_bottom.png">
    </div>

    <div class="block-subscr-menus" v-if="hasResult">
      <block-houen-menus
        v-for="(item, idx) in menusList"
        :key="`list${idx}`"
        :menu-data="item"
        :enable-icon="false"
        :color-scheme="counselorInfos.colorScheme"
      />
    </div>

    <!-- <link-menu-block /> -->
    <!-- <banner-block /> -->
    <recommend-block-plus
      :recommend-data="standardRecommendData"
      :color-scheme="recommendColorScheme"
    />
  </div>
</template>

<script>
import {BASIC_DATA, DEFAULT_FOOTER_MENULIST } from '@/utvStore/components/recommend/lp/commons'
import { mapState, mapGetters } from 'vuex'
import moment from 'moment'
import * as type from '@/utvStore/store/mutation-types'
import RegistBirthdate from '../partials/RegistBirthdate'
import BannerBlock from '../partials/BannerBlock'
import LinkMenuBlock from '../partials/LinkMenuBlock'
import BlockResultType03 from '../partials/BlockResultType03'
import BlockHouenMenus from '../partials/BlockHouenMenus'
import RecommendBlockPlus from '@/utvStore/components/common/RecommendBlockPlus'

export default {
  name: 'ProductsResult04',
  components: {
    RecommendBlockPlus,
    BlockResultType03,
    RegistBirthdate,
    BannerBlock,
    LinkMenuBlock,
    BlockHouenMenus,
  },
  props: {
    pageId: {
      type: String,
      required: true,
    },
    resultData: {
      //type: Object,
      type: [Object, Array],
      default: null,
    },
    requireProf: {
      type: Array,
      default: null,
    },
    standardRecommendData: {
      type: Array,
    },
    csrfToken: {
      type: String,
      default() {
        return ''
      }
    },
  },
  computed: {
    ...mapState({
      userInfo: state => state.account.user,
      userProf: state => state.account.profile,
      subscInfo: state => state.account.subscription
    }),
    hasResult() {
      return !!this.resultData && (Array.isArray(this.resultData) ? this.resultData.length > 0 : Object.keys(this.resultData).length > 0)
    },
    menusList() {
      if(this.hasResult && this.resultData.menu_list && this.resultData.menu_list.length > 0){
        return this.resultData.menu_list.filter(item => {
          return !!item.list && item.list.length > 0
        })
      }
    },
    counselorInfos(){
      return BASIC_DATA.houen
    },
    recommendColorScheme() {
      return {
        keyColor: this.counselorInfos.colorScheme.keyColor,
      }
    },
    styles(){
      return {
        '--key-color': this.counselorInfos.colorScheme.keyColor,
        '--mess-bg': this.counselorInfos.colorScheme.messBg,
        '--second': this.counselorInfos.colorScheme.second,
      }
    },
  },
  created() {
    this.$store.dispatch(type.SET_COLOR_SCHEME, this.counselorInfos.colorScheme)
  },
  mounted() {
  },
  methods: {
  },
}</script>

<style scoped lang='scss'>
@import "../../../../../../sass/commons/commonVariables";
@import "../../../../../../sass/commons/styles/fonts";


$title-fontfamily:'Hiragino Mincho Pro';

.products-result-base {
  background: url(/static/img/recommend/lp/houen/products/bk_result.png) repeat #f8f5ed;
  background-size: contain;
  .header-area{
    background: white;
    h1{
      margin: 0;
      img {
        display: block;
        width: 100%;
      }
    }
    .link-block {
      padding: 0 20px;
      a {
        color: var(--second);
      }
    }
  }

  .result-panel-base{
    .target-text{
      //font-family: 'Hiragino Kaku Gothic Pro';
      font-style: normal;
      //font-weight: 300;
      font-size: 14px;
      line-height: 24px;
      color: $col_base_black;
      margin-bottom: 24px;
    }
    .target-title{
      //font-family: 'Hiragino Kaku Gothic Pro';
      font-style: normal;
      font-weight: 700;
      font-size: 18px;
      line-height: 24px;
      text-align: center;
      color:var(--key-color);
      margin-bottom: 20px;
    }
  }

  /deep/ {
    .result-base {
      background: white;
      position: relative;
      margin-bottom: 60px;
      &::after {
        content: "";
        display: block;
        width: 100%;
        height: 0;
        padding-top: 6.13%;
        background: url(/static/img/recommend/lp/houen/products/bg_under_curve.svg) no-repeat center top;
        background-size: 100% auto;
        position: absolute;
        top: 100%;
        left: 0;
      }
    }
  }

  .block-regist-info{
    position: relative;
    background: #f8f5ed;
    .line-top{
      position: absolute;
      top: -13px;
      height: auto;
      width: 100%;
    }
    .line-bottom{
      width: 100%;
      height: auto;
      position: absolute;
      bottom: -12px;
    }
  }
  .regist-birthdate{
    background: #fff;
    border-radius: 0px;
  }


  .block-subscr-menus {
    padding: 40px 20px 24px;
    .block-houen-menus {
      margin-bottom: 20px;
      &:last-child{
        margin-bottom: 0;
      }
    }
  }


}
/deep/{
  .block-banners img{
    width: 100%;
  }
}

</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/Products/houen/fortunes/ProductsResult05.vue